
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.15 21.87v20.8l10.53-10.38-10.53-10.42zM32.68 35.62l-.38-.38 15.06-14.83-30.22.01 15 14.82.54.38z"}}),_c('path',{attrs:{"d":"M32.86 37.13a.93.93 0 01-1.29 0l-3.65-3.59-10.75 10.57h29.92L36.45 33.6zM48.32 42.88V21.9L37.69 32.38l10.63 10.5z"}}),_c('path',{attrs:{"d":"M32 0a32 32 0 1032 32A32 32 0 0032 0zm18.07 44.94a.93.93 0 01-.91.91H15.32a.92.92 0 01-.92-.9V19.58a.91.91 0 01.9-.91h33.86a.91.91 0 01.91.91z"}})])
          )
        }
      }
    